var map = {
	"./IMG_0937.jpg": 17,
	"./IMG_0938.JPG": 18,
	"./IMG_1339.JPG": 19,
	"./IMG_1340.jpg": 20,
	"./IMG_1408.JPG": 21,
	"./IMG_1409.JPG": 22,
	"./IMG_1410.JPG": 23,
	"./IMG_1411.JPG": 24,
	"./IMG_1455.JPG": 25,
	"./IMG_1455X.JPG": 26,
	"./banana_tarte.JPG": 27,
	"./biscuits.JPG": 28,
	"./blueberry_lemon.JPG": 29,
	"./cc_cookies.JPG": 30,
	"./challah.JPG": 31,
	"./cheesecake.JPG": 32,
	"./cream_puffs.JPG": 33,
	"./croissants.JPG": 34,
	"./demisec.JPG": 35,
	"./eclairs.JPG": 36,
	"./fougasse.JPG": 37,
	"./fraisent.JPG": 38,
	"./fraispetitfour.JPG": 39,
	"./gruyere_rolls.JPG": 40,
	"./lemon_danish.JPG": 41,
	"./macaron_pack.JPG": 42,
	"./maracaibo.JPG": 43,
	"./mushroom_dartois.JPG": 44,
	"./napolean.JPG": 45,
	"./pain_au_lait.JPG": 46,
	"./painaulait.jpeg": 47,
	"./palmiers.JPG": 48,
	"./sabayon.JPG": 49,
	"./star.jpg": 50,
	"./sticky_bun.JPG": 51,
	"./strip.JPG": 52,
	"./tdb_logo.svg": 53,
	"./thumb-me.jpg": 54,
	"./thumb_me_dark.JPG": 55,
	"./turnovers.JPG": 56
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16;